import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import type { CountryEntity } from '@shared/api';
import { Input } from '@shared';

interface IFamilyWealthProps {
  name: string;
  countries: CountryEntity[];
}

export const FamilyWealth = (props: IFamilyWealthProps) => {
  const { control } = useFormContext();

  return (
    <>
      <Grid item xs={4}>
        <Controller
          name={`${props.name}.description`}
          control={control}
          rules={{ required: 'Description is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Description' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <Controller
          name={`${props.name}.relation`}
          control={control}
          rules={{ required: 'Relation is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Relation' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <Controller
          name={`${props.name}.country`}
          control={control}
          rules={{ required: 'Country is required' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <FormControl margin='normal' fullWidth error={!!error}>
                <InputLabel>Country *</InputLabel>
                <Select {...field} variant='standard' fullWidth>
                  {props.countries.map((country, idx) => (
                    <MenuItem key={idx} value={country.name}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error?.message}</FormHelperText>
              </FormControl>
            </>
          )}
        />
      </Grid>
    </>
  );
};
